import { useState, useCallback } from 'react';
import { pw220aApi, F21A0 } from '../../../services/pw220aApi';
import { message } from 'antd';

export function usePW220ANavigation(onLoad: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const loadList = useCallback(async () => {
    try {
      const res = await pw220aApi.list(1, 1000);
      const ids = (res.data as F21A0[]).map((r) => r.f21a0_01);
      setAllIds(ids);
      if (ids.length > 0) {
        setCurrentIdx(ids.length - 1);
        await onLoad(ids[ids.length - 1]);
      }
    } catch {
      message.error('載入清單失敗');
    }
  }, [onLoad]);

  const navTo = useCallback(
    async (idx: number) => {
      if (idx < 0 || idx >= allIds.length) return;
      setCurrentIdx(idx);
      await onLoad(allIds[idx]);
    },
    [allIds, onLoad]
  );

  const navFirst = useCallback(() => navTo(0), [navTo]);
  const navPrev = useCallback(() => navTo(currentIdx - 1), [navTo, currentIdx]);
  const navNext = useCallback(() => navTo(currentIdx + 1), [navTo, currentIdx]);
  const navLast = useCallback(() => navTo(allIds.length - 1), [navTo, allIds.length]);

  const appendId = useCallback((id: string) => {
    setAllIds((prev) => {
      if (prev.includes(id)) return prev;
      const next = [...prev, id];
      setCurrentIdx(next.length - 1);
      return next;
    });
  }, []);

  const removeId = useCallback(
    (id: string) => {
      setAllIds((prev) => {
        const next = prev.filter((x) => x !== id);
        const newIdx = Math.min(currentIdx, next.length - 1);
        setCurrentIdx(newIdx);
        return next;
      });
    },
    [currentIdx]
  );

  return {
    allIds,
    currentIdx,
    loadList,
    navTo,
    navFirst,
    navPrev,
    navNext,
    navLast,
    appendId,
    removeId,
  };
}
